import type { FunctionComponent } from 'react';

import { PillSwitcher } from '../../../shared/components/pill-switcher/pill-switcher';

export const ResponsibleGamingMenu: FunctionComponent = () => {
    return (
        <PillSwitcher
            items={[
                // {
                //     id: 'casino-budget-limits',
                //     name: 'responsible-gaming-menu.casino-budgets-limits.label',
                //     href: '/account/responsible-gaming/casino-budget-limits',
                // },
                {
                    id: 'sports-budget-limits',
                    name: 'responsible-gaming-menu.sports-budgets-limits.label',
                    href: '/account/responsible-gaming/sports-budget-limits',
                },
                {
                    id: 'despoit-budget-limits',
                    name: 'responsible-gaming-menu.deposit-limits.label',
                    href: '/account/responsible-gaming/deposit-budget-limits',
                },
                // {
                //     id: 'session-limits-continuous',
                //     name: 'responsible-gaming-menu.session-limits-continuous.label',
                //     href: '/account/responsible-gaming/session-limits-continuous',
                // },
                {
                    id: 'session-limits-cumulative',
                    name: 'responsible-gaming-menu.session-limits-cumulative.label',
                    href: '/account/responsible-gaming/session-limits-cumulative',
                },
                {
                    id: 'self-exclusion',
                    name: 'responsible-gaming-menu.self-exclusion.label',
                    href: '/account/responsible-gaming/self-exclusion',
                },
            ]}
        />
    );
};
